import { useCallback, useRef } from "react";

/**
 * Handlers for an element that highlights something on the photo: hovering with a mouse shows it while the
 * pointer is over the element, a tap on a touch screen (no hover there) toggles it.
 */
export function useHoverHighlight<T>(current: T | null, set: (value: T | null) => void) {
  const pointerType = useRef<string>("mouse");

  return useCallback(
    (value: T) => ({
      onPointerDown: (event: React.PointerEvent) => {
        pointerType.current = event.pointerType;
      },
      onPointerEnter: (event: React.PointerEvent) => {
        if (event.pointerType === "mouse") set(value);
      },
      onPointerLeave: (event: React.PointerEvent) => {
        if (event.pointerType === "mouse") set(null);
      },
      onClick: () => {
        if (pointerType.current !== "mouse") set(current === value ? null : value);
      },
      "data-highlighted": current === value ? "" : undefined,
    }),
    [current, set],
  );
}
